import { Component, OnInit } from '@angular/core';
import { IInfo, Info } from '../../../../../core/common';
import { IMasterData, IV6OptionTranslation, MasterData, V6OptionTranslation } from '../../../../../core/models';
import { ProductService } from '../../../../../core/services/product.service';

@Component({
  selector: 'app-add-translation',
  templateUrl: './add-translation.component.html',
  styleUrls: ['./add-translation.component.scss']
})
export class AddTranslationComponent implements OnInit {

  constructor(private productService: ProductService) { }
  productCode = [];
  dummyProductCode = [];
  ngOnInit() {
    this.productService.GetProductCode().subscribe(productCodeResponse => {
      this.productCode = productCodeResponse;
      this.dummyProductCode = productCodeResponse;//this.productCode;
    });

  }

  isSubmitted: boolean = false;
  saveInProcess: boolean = false;
  addTranslation: IV6OptionTranslation = new V6OptionTranslation();
  public inProgressMessage: boolean;
  public successMessage: boolean;
  public errorMessage: boolean;
  public infoMessage: IInfo = new Info();


  validateForm(): boolean {
    return true;
  }


  public value: any = [];

  handleFilter(event) {
    //console.log(event);
    //console.log(this.dummyProductCode);
    //let keys = Object.assign({}, this.dummyProductCode)
    //console.log(keys);
    this.productCode = this.dummyProductCode.filter(
      (s) => s ? s.toLowerCase().indexOf(event.toLowerCase()) > -1 : false
    );
  }
  addTranslationToSave(): void {
    this.isSubmitted = true;
    if (this.value) {
      this.addTranslation.optionApplicableProducts = this.value.join("|");
    }
    //return;
    if (!this.validateForm()) {
      return;
    }
    this.infoMessage = new Info();
    this.inProgressMessage = true;
    this.saveInProcess = true;
    this.infoMessage.genericInProgress = this.infoMessage.genericInProgress;
    this.productService.AddTranslation(this.addTranslation).subscribe(response => {
      if (response) {
        this.infoMessage.genericInProgress = "";
        this.saveInProcess = false;
        this.infoMessage.genericSuccess = this.infoMessage.genericSuccess;
      } else {
        this.infoMessage.genericError = this.infoMessage.genericError;
      }
      this.addTranslation = new V6OptionTranslation();
      this.value = [];
    });
  }
}
